export class OperationalTipoMoneda {

  static path = '/parametricas/tipos_monedas/no_cripto/';
  id: number;
  simbolo: string;

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/operationalTipoMoneda.model.ts